import React, { useEffect, useState } from "react";
import { createCourse, getAllLevelWithCount, getAllParentCourse, getStatus } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { useRef } from "react";
import { toBase64 } from "../../Services/commonHelper";

const AddCourse = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        parent_id: "",
        name: "",
        slug: "",
        duration: "", 
        description: "",
        image: "",
        background_image: "", 
        status: "",
        description: "", 
        dept_code: "", 
        for_india: "", 
        alias: "", 
        popular_name: "", 
        level_id: "", 
        course_type: "", 

    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const [parent, setParent] = useState([]);
    const [level, setLevel] = useState([]);
    const [previewImage, setPreviewImage] = useState({
        image: "",
        background_image: ""
    });
    const uploadRef = useRef(null);
    const uploadLogoRef = useRef(null);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCourse(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const getParentCall = async () => {
        let { ok, data } = await getAllParentCourse({});
        if (ok) {
            setParent(data);
        }
    };

    const getLevelCall = async () => {
        let { ok, data } = await getAllLevelWithCount({});
        if (ok) {
            setLevel(data?.records);
        }
    };

    useEffect(() => {
        getParentCall();
        getStatusCall();
        getLevelCall();
        if (data?.data) {
            const { id, parent_id, name, description, status, slug, duration, image, background_image, dept_code, for_india, alias, popular_name, course_type, level_id } = data?.data;
            setReqData({ id, parent_id, name, slug, duration, description, image, background_image, status, dept_code, for_india, alias, popular_name, course_type, level_id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Course" : "Edit Course"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Popular Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Popular Name"
                                                value={reqData?.popular_name}
                                                onChange={(e) => handleChange("popular_name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Parent</label>
                                            <select required value={reqData?.parent_id} onChange={(e) => handleChange("parent_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Parent</option>
                                                {parent?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Slug</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Slug"
                                                required
                                                value={reqData?.slud}
                                                onChange={(e) => handleChange("slug", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Duration</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Duration"
                                                required
                                                value={reqData?.duration}
                                                onChange={(e) => handleChange("duration", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Department Code</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Department Code"
                                                required
                                                value={reqData?.dept_code}
                                                onChange={(e) => handleChange("dept_code", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Alias</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Alias"
                                                required
                                                value={reqData?.alias}
                                                onChange={(e) => handleChange("alias", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>For India</label>
                                            <select required value={reqData?.for_india} onChange={(e) => handleChange("for_india", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="" selected>Select</option>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Level</label>
                                            <select required value={reqData?.level_id} onChange={(e) => handleChange("level_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                {level?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Course Type</label>
                                            <select required value={reqData?.course_type} onChange={(e) => handleChange("course_type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="" selected>Select</option>
                                                <option value={"Regular Classroom"}>Regular Classroom</option>
                                                <option value={"Short-term Program"}>Short-term Program</option>
                                                <option value={"Summer Program"}>Summer Program</option>
                                                <option value={"Certification"}>Certification</option>
                                                <option value={"Others"}>Others</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.image ? "Change Image" : "Add Image"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.image || reqData?.image) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.image ? previewImage?.image : reqData?.image}
                                            />}
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.background_image ? "Change Background" : "Add Background"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.background_image || reqData?.background_image) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.background_image ? previewImage?.background_image : reqData?.background_image}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "background_image")} />
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "image")} />
        </div>
    );
};

export default AddCourse;